import { B2bPlanCategoryEsPerecoiValues } from '@Common/types/b2b/plans';
import {
  CustomB2bTemplatePlanItem,
  GetBoInvestorProfileIdEndpoint,
} from '@Common/types/bo/b2b/investor_profile';

export const PERECO_GRID_LENGTH = 26;
export const PEE_GRID_LENGTH = 1;

export type InvestorProfileGridInstrumentAllocation = {
  instrument_id: number;
  allocation: number[];
};

export type InvestorProfileGridSupportedPlanCategories =
  | 'PEE'
  | 'PEEG'
  | 'PEI'
  | 'PERECO'
  | 'PERECOG'
  | 'PERECOI'
  | 'PERCO';

const initFormattedCustomGrid = (grid: CustomB2bTemplatePlanItem['allocations']) => {
  const instruments: number[] = [];

  grid.forEach((gridRow) => {
    gridRow.allocation_instruments.forEach((instrumentAllocation) => {
      if (!instruments.includes(instrumentAllocation.instrument_id)) {
        instruments.push(instrumentAllocation.instrument_id);
      }
    });
  });

  return instruments.map((instrumentId) => ({
    instrument_id: instrumentId,
    allocation: [],
  }));
};

export const transformBoGridToFormGrid = (
  grid: CustomB2bTemplatePlanItem['allocations'] | undefined,
  gridType: Extract<
    GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['plan_category'],
    InvestorProfileGridSupportedPlanCategories
  >,
): InvestorProfileGridInstrumentAllocation[] => {
  const finalGrid: CustomB2bTemplatePlanItem['allocations'] =
    grid
      ?.slice(
        0,
        B2bPlanCategoryEsPerecoiValues.some((perecoiValue) => gridType === perecoiValue)
          ? PERECO_GRID_LENGTH
          : PEE_GRID_LENGTH,
      )
      .reverse() ?? [];
  const tmp: InvestorProfileGridInstrumentAllocation[] = initFormattedCustomGrid(finalGrid);

  tmp.forEach((instrumentAllocation, index) => {
    finalGrid.forEach((gridRow) => {
      const relatedRowAllocation = gridRow.allocation_instruments.find(
        (column) => column.instrument_id === instrumentAllocation.instrument_id,
      );
      tmp
        .at(index)
        ?.allocation.push(
          relatedRowAllocation !== undefined ? relatedRowAllocation.allocation_percent : 0,
        );
    });
  });

  return tmp;
};
